import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Logo/home link: signed-in users go to their dashboard (and stay signed in), visitors go to the home page
export const HomeLink = ({ children, to: _ignored, ...props }) => {
  const { user } = useAuth();
  return <Link to={user ? '/dashboard' : '/'} {...props}>{children}</Link>;
};

// "Sign In" for visitors, "Dashboard" once signed in
export const AccountLink = ({ className }) => {
  const { user } = useAuth();
  return (
    <Link to={user ? '/dashboard' : '/login'} className={className} data-testid="account-link">
      {user ? 'Dashboard' : 'Sign In'}
    </Link>
  );
};

export default HomeLink;
